import { useState, useRef, useEffect } from 'react';
import { Breakpoint, useBreakpoint } from '@helsenorge/designsystem-react/hooks/useBreakpoint';
export const DELAY_BEFORE_SCROLLING_ON_LOAD_MS = 250;
// Get the height in pixels of an element
export const getHeightOfElement = (element) => {
    const { height = 0 } = element.getBoundingClientRect() ?? {};
    return height;
};
/**
 * Finds first visible element from a list of elements
 * @param targetRefs targetRefs: List of elements to check
 * @param offsetRef offsetRef: Element to use as an offset (eg. a sticky element that hides content underneath it)
 * @param attribute Attribute to get value of
 * @returns A function to smooth scroll to an element, and optionally the value of an attribute of that element
 */
const useScrollingElementList = (targetRefs, offsetRef, attribute) => {
    const ticking = useRef(false);
    const breakpoint = useBreakpoint();
    const isMobile = breakpoint < Breakpoint.md;
    const [attributeValue, setAttributeValue] = useState();
    const scrollToElementByIndex = (index) => {
        const offset = offsetRef?.current && !isMobile // Ignore offset element on mobile
            ? getHeightOfElement(offsetRef.current)
            : 0;
        if (targetRefs.current[index].current) {
            const { top: distanceFromWindowToElement = 0 } = targetRefs.current[index].current?.getBoundingClientRect() ?? {};
            window.scrollBy({
                top: distanceFromWindowToElement - offset - 16,
                behavior: 'smooth',
            });
        }
    };
    useEffect(() => {
        const handleScroll = () => {
            ticking.current = false;
            const heightOfOffsetElement = offsetRef?.current && !isMobile // Ignore offset element on mobile
                ? getHeightOfElement(offsetRef.current)
                : 0;
            const first = targetRefs.current.find(element => {
                const { bottom: distanceToBottomOfElement = 0, height: heightOfElement = 0 } = element.current?.getBoundingClientRect() ?? {};
                return distanceToBottomOfElement - heightOfElement * 0.382 > heightOfOffsetElement;
            });
            if (attribute) {
                setAttributeValue(first?.current?.getAttribute(attribute) ?? undefined);
            }
        };
        const onScroll = () => {
            // Throttle the scroll listener to around 60 fps (or whatever the web browser thinks is OK)
            if (!ticking.current) {
                requestAnimationFrame(handleScroll);
            }
            ticking.current = true;
        };
        window.addEventListener('scroll', onScroll, false);
    }, [isMobile, offsetRef, targetRefs, attribute]);
    return { scrollToElementByIndex, attributeValue };
};
export default useScrollingElementList;
